import { TAuthInfoFee, } from '../../../types/TxCosmosApi';
import { Table, TableBody } from '@mui/material';
import { Row, SectionWrapper } from '../../../components/tableComponents';
import DenomRow from '../../../components/DenomRow';


type props = {
    fee: TAuthInfoFee,
  }
  
const TxFee = ({fee}: props) => {
    return (<>
        <h4>Fee:</h4>
        <SectionWrapper>
          <Table  aria-label="overview snapshot table">
              <TableBody>
                  <Row field='Payer' value={fee.payer} hasCopyOption route={`/snapshots/${fee.payer}`}/>
                  <Row field='Granter' value={fee.granter} hasCopyOption route={`/snapshots/${fee.granter}`}/>
                  <Row field='Gas limit' value={fee.gas_limit}/>
                  <Row field='Amount: ' remBorder={true} boldProperty={true}/>
                  {fee.amount.map((a) => {
                    return (
                      <DenomRow  denom={a.denom} amount={a.amount} key={a.denom + a.amount}/>
                      )
                    })
                  }
              </TableBody>
          </Table>
        </SectionWrapper>
      </>
    )
}

export default TxFee;